import { FC } from 'react';
import Image from '@base/lib/ThemeImage';
import { IBannerProps } from 'mod/featureV2/Banner/interface';
import { IBannerImage } from 'mod/featureV2/interface/banner';
import { getBannerStyle } from 'mod/featureV2/Banner/utils';

export const BannerImage: FC<IBannerProps<IBannerImage>> = props => {
    const {
        banner,
        width,
        height,
        onClick
    } = props;

    return (
        <Image
            className={'g-banner'}
            style={getBannerStyle(props)}
            href={banner.href}
            target={banner.target}
            src={banner.src}
            alt={banner.alt}
            width={width}
            height={height}
            background={banner.bgColor}
            fit={'cover'}
            onClick={onClick}
        />
    )
};
